import React from 'react';
import backgroundImage from "../assets/indian_trucker2.jpeg";
const Banner = ({ title, subtitle }) => {
  return (
    <div className="relative w-full h-52 font-ubuntu md:h-64 lg:h-[500px]">
      <img src={backgroundImage} alt="Banner" className="w-full h-full object-cover" />
      <div className="absolute inset-0  flex flex-col justify-center items-center text-center text-white ">
        <h1 className="text-2xl sm:text-3xl md:text-4xl text-white lg:text-8xl font-bold">{title}</h1>
        <p className="text-base sm:text-lg md:text-xl text-white lg:text-2xl font-normal mt-2">{subtitle}</p>
      </div>
    </div>
  );
};

export default Banner;